module.exports = __webpack_public_path__ + "img/beat-brewing-a-go-go.ebc20265.png";